<template>
  <div :class="classColumns">
    <div class="l-row">
      <form-group label="Tipo de preço padrão" :columns="numberColumns" :error="getError('price.type')">
        <select v-model="input.type" class="form-select" :disabled="block">
          <option :value="null">Selecione</option>
          <option v-for="priceType in priceTypeDI" :value="priceType">
            {{ priceType === 'source' ? $t('priceTypeModule.label') + $t(moduleLabel) : $t(priceType).label }}
          </option>
        </select>
      </form-group>

      <form-group label="Percentual" v-if="input.type === 'percent'" :columns="6" :required="true">
        <div class="form-flex">
          <input class="form-input" type="text" v-model="input.percent">
          <span class="form-addon">%</span>
        </div>
      </form-group>

      <form-group label="Valor fixo" v-if="input.type === 'fixedValue'" :columns="6" :required="true">
        <div class="form-flex">
          <money v-model="input.fixedValue" v-bind="money" class="form-input" type="text"/>
        </div>
      </form-group>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import FormGroup from '@/components/template/FormGroup'
  import { Money } from 'v-money'

  export default {
    inject: ['priceTypeDI'],
    data: () => ({
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    }),
    props: {
      block: {
        type: Boolean,
        required: false,
        default: false
      },
      errors: {
        type: Array,
        required: false
      },
      input: {
        type: Object,
        required: true
      },
      editable: {
        type: Boolean,
        default: true
      },
      module: {
        type: Object,
        default: null
      },
      required: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      numberColumns () {
        return ['percent', 'fixedValue'].indexOf(this.input.type) !== -1 ? 6 : 12
      },
      classColumns () {
        return ['percent', 'fixedValue'].indexOf(this.input.type) !== -1 ? 'l-col-6@md' : 'l-col-3@md'
      },
      moduleLabel () {
        if (this.module == null) {
          return 'module.label'
        }

        return this.module.identifier + '.label'
      }
    },
    watch: {
      'input.type' (value) {
        if (value !== 'percent') {
          this.input.percent = null
        }

        if (value !== 'fixedValue') {
          this.input.fixedValue = null
        } else {
          this.input.fixedValue = this.input.fixedValue > 0 ? this.input.fixedValue : 0.0
        }
      }
    },
    components: {
      FormGroup,
      Money
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ProductPriceConfiguration.vue?83f37452